import { FC } from 'react'

import { CreateModeSelectDialog } from 'bank-contacts/src/components'
import { Contact } from 'commons/types/DTO/bank/companyDetails/contact'
import { TableDataQa } from 'commons/types/enums'
import { Layer, PageSectionPrimary, Table } from 'ui/components'
import { ButtonGroup } from 'ui/components/ButtonGroup'
import { Button } from 'ui/components/Buttons'

import { CompanyContactsTableProps } from './CompanyContactsTableProps'
import { columns } from './columns'
import { Filter } from './components'
import { useComponentsEssence } from './hooks/useComponentsEssence'

export const CompanyContactsTable: FC<CompanyContactsTableProps> = (props) => {
  const {
    data: { contacts, contactsTotalCount, contactsTypeOptions, id }
  } = props
  const {
    webPageData,
    isFetching,
    tableState,
    filterForm,
    changePagination,
    DeleteConfirmation,
    onDeleteContact,
    openedAddModeDialog,
    setOpenedAddModelDialog,
    onSubmitChooseAddModeDialog,
    clearFilter,
    onEditContactMetaData
  } = useComponentsEssence(id, contacts, contactsTotalCount)

  return (
    <PageSectionPrimary
      title="Contacts"
      anchor="contacts"
      actions={
        <ButtonGroup margin="small">
          <Button face="tertiary" onClick={() => setOpenedAddModelDialog(true)}>
            Add New
          </Button>
        </ButtonGroup>
      }
      face="outlined"
    >
      <DeleteConfirmation />
      <CreateModeSelectDialog
        isOpen={openedAddModeDialog}
        onClose={() => setOpenedAddModelDialog(false)}
        onSubmit={onSubmitChooseAddModeDialog}
      />
      <Layer rounded shadowed stretch>
        <Filter
          form={filterForm}
          expanded={tableState.expanded}
          onToggle={tableState.onFilterToggle}
          contactsTypeOptions={contactsTypeOptions}
          onClear={clearFilter}
        />
        <Table<Contact>
          dataQa={TableDataQa.BP_COMPANY_CONTACTS}
          columns={columns(onDeleteContact, onEditContactMetaData)}
          dataSource={webPageData.contacts.map((el) => ({
            item: el
          }))}
          loading={isFetching}
          pagination={{
            page: tableState.page,
            size: tableState.size,
            onChange: changePagination,
            total: webPageData.contactsTotalCount
          }}
        />
      </Layer>
    </PageSectionPrimary>
  )
}
